import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section id="home" className="hero-section" aria-label="Hero section">
      <video autoPlay loop muted playsInline className="hero-video">
        <source src="/videos/videonum1.mov" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1 className="hero-name">MELODIA MUSIC</h1>
      </div>
    </section>
  );
};

export default Hero;
